import * as i from 'io-ts';
export * as Attachments from './attachments';
// TODO: newtype? probably overkill atm as particles are just an id
export const Id = i.string;
export const Particle = i.type({ id: Id });
export const construct = (id) => ({
    id,
});
export const id = (particle) => particle.id;
export const getModelUrl = (serviceUrls, particle) => `${serviceUrls.models}/${id(particle)}.glb`;
export const getAttachmentsUrl = (serviceUrls, particle) => `${serviceUrls.models}/${id(particle)}.v2.json`;
